import { AssetClassTag } from './asset-class.interface';
import { Entity } from '../../../../domain/entity';
import { validationProvider } from '../../../../infrastructure/validation/validation.provider';
import { AssetClassCreatedEvent, } from './event/asset-class-created.event';
import { AssetClassDeletedEvent, } from './event/asset-class-deleted.event';
import { AssetClassNameSetEvent, } from './event/asset-class-name-set.event';
import { AssetsImportedEvent } from './event/assets-imported.event';
import { AssetsPurgedEvent } from './event/assets-purged.event';
import { AssetClassPutEvent } from './event/asset-class-put.event';
import projections from './projections-index';
export class AssetClassEntity extends Entity {
    constructor(properties) {
        super(properties.id);
        this._name = validationProvider.validateAndTransformString(properties.name, {
            name: 'Name',
            required: true,
        });
        this._tenantId = validationProvider.validateAndTransformId(properties.tenantId, {
            name: 'Tenant ID',
            required: true,
        });
        this._tag = validationProvider.validateAndTransformEnumValue(properties.tag, Object.values(AssetClassTag), { name: 'AssetClass Tag' });
        this._tp2LayerName = validationProvider.validateAndTransformString(properties.tp2LayerName, {
            name: 'TP2 Layer Name',
        });
    }
    create(metadata) {
        return new AssetClassCreatedEvent({
            id: this.id,
            name: this.name,
            tenantId: this.tenantId,
            tag: this.tag,
            tp2LayerName: this.tp2LayerName,
        }, metadata);
    }
    delete(metadata) {
        return new AssetClassDeletedEvent({
            id: this.id,
            deleted: true,
        }, metadata);
    }
    setName(name, metadata) {
        if (name !== undefined) {
            this.name = validationProvider.validateAndTransformString(name, {
                name: 'Name',
                required: true,
            });
        }
        return new AssetClassNameSetEvent({
            id: this.id,
            name: this.name,
        }, metadata);
    }
    importAssets(metadata) {
        return new AssetsImportedEvent({
            id: this.id,
        }, metadata);
    }
    purgeAssets(metadata) {
        return new AssetsPurgedEvent({
            id: this.id,
        }, metadata);
    }
    put(properties, metadata) {
        this._name = validationProvider.validateAndTransformString(properties.name, {
            name: 'Name',
            required: true,
        });
        this._tenantId = validationProvider.validateAndTransformId(properties.tenantId, {
            name: 'Tenant ID',
            required: true,
        });
        if (properties.tag !== undefined) {
            this._tag = validationProvider.validateAndTransformEnumValue(properties.tag, Object.values(AssetClassTag), { name: 'AssetClass Tag' });
        }
        if (properties.tp2LayerName !== undefined) {
            this._tp2LayerName = validationProvider.validateAndTransformString(properties.tp2LayerName, {
                name: 'TP2 Layer Name',
            });
        }
        return new AssetClassPutEvent({
            id: this.id,
            name: this.name,
            tenantId: this.tenantId,
            tag: this.tag,
            tp2LayerName: this.tp2LayerName,
        }, metadata);
    }
    static restoreAggregateState(events, snapshot) {
        return super.buildAggregateState(events, projections, snapshot);
    }
    static getFieldFromTag(fields, tag) {
        return fields.find(field => field.tag === tag);
    }
    get name() {
        return this._name;
    }
    set name(name) {
        this._name = name;
    }
    get tenantId() {
        return this._tenantId;
    }
    get tag() {
        return this._tag;
    }
    set tag(tag) {
        this._tag = tag;
    }
    get tp2LayerName() {
        return this._tp2LayerName;
    }
    set tp2LayerName(tp2LayerName) {
        this._tp2LayerName = tp2LayerName;
    }
}
//# sourceMappingURL=asset-class.model.js.map